<template>
  <div class="comment-wrap" style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e5e5;">
    <h3 style="margin-bottom: 18px;">({{ commentnum }}) 留言</h3>

    <div v-if="userinfo" style="margin-bottom: 12px; display: flex; align-items: center;">
      <img :src="userinfo.avatar || $img.portrait" style="width: 40px; height: 40px; border-radius: 50%; margin-right: 10px;" />
      <span>{{ userinfo.nickname }}</span>
    </div>
    <div v-else style="margin-bottom: 12px; color: #888; font-size: 13px;">
      请先 <a style="color: #0E7490; cursor: pointer;" @click="$store.dispatch('user/close', true)">登录</a> 后发表评论
    </div>

    <div v-if="editorid === -1" style="margin-bottom: 16px;">
      <el-button type="info" size="small" @click="editorid = 0" v-if="editorid === -1 && userinfo">添加评论</el-button>
    </div>
    <div v-if="editorid === 0 && userinfo" style="margin-bottom: 16px;">
      <el-input type="textarea" :rows="4" v-model="comment_content" placeholder="请输入评论内容"></el-input>
      <el-button type="primary" size="small" style="margin-top: 8px;" @click="setcomment">评论</el-button>
      <el-button size="small" style="margin-top: 8px;" @click="editorid = -1">取消</el-button>
    </div>

    <ol class="commentlist" style="margin: 0;">
      <li v-for="item in commentlist" :key="item.comment_id" style="padding: 14px 0; border-bottom: 1px dashed #eee;">
        <div style="display: flex;">
          <el-popover placement="right" width="260" trigger="hover">
            <div style="text-align: center; padding: 6px 0;">
              <img :src="item.avatar" style="width: 64px; height: 64px; border-radius: 50%;" />
              <p style="margin: 8px 0 4px; font-weight: bold;">{{ item.nickname }}</p>
              <p style="color: #0E7490; font-size: 13px;">{{ item.realstate == 3 ? '认证用户' : '未认证用户' }}</p>
              <p style="font-size: 12px; color: #888;">账号：{{ item.username }}</p>
              <p style="font-size: 12px; color: #888;">邮箱：{{ item.mail }}</p>
              <p style="font-size: 12px; color: #888;">QQ：{{ item.qq }}</p>
              <p style="font-size: 12px; color: #888; margin-top: 6px;">{{ item.synopsis }}</p>
              <el-button type="danger" size="mini" plain style="margin-top: 8px;" @click="reportUser(item)">举报</el-button>
            </div>
            <div slot="reference">
              <img :src="item.avatar" style="width: 44px; height: 44px; border-radius: 50%; cursor: pointer;" />
            </div>
          </el-popover>
          <div style="flex: 1; margin-left: 12px;">
            <p>
              <strong>{{ item.nickname }}</strong>
              <span style="color: #999; font-size: 12px; margin-left: 10px;">{{ item.comment_createtime | dataFormat }}</span>
            </p>
            <div v-html="item.comment_content" style="font-size: 14px; line-height: 1.8; margin: 8px 0;"></div>
            <p style="font-size: 12px; color: #0E7490; cursor: pointer;" @click="getreplybutton(item)">查看所有回复 ({{ item.child ? item.child.length : 0 }})</p>
            <p style="font-size: 12px; color: #0E7490; cursor: pointer; margin-left: 10px; display: inline-block;" @click="showinput(item)">回复</p>

            <ul v-if="item.showreply" style="margin: 8px 0 0; background: #f8f9fa; padding: 10px 14px; border-radius: 3px;">
              <li v-for="data in item.child" :key="data.reply_id" style="padding: 6px 0; font-size: 13px; border-bottom: 1px dashed #e5e5e5;">
                <strong>{{ data.nickname }}</strong>
                <span style="color: #999;"> 回复 </span>
                <strong>@{{ data.tousernickname }}</strong>
                <span style="color: #999; margin-left: 8px;">{{ data.createtime | dataFormat }}</span>
                <div v-html="data.reply_content" style="margin-top: 4px;"></div>
                <span style="color: #0E7490; cursor: pointer; font-size: 12px;" @click="showreplyinput(item, data)">回复</span>
              </li>
              <li v-if="item.replyeditor" style="padding-top: 8px;">
                <el-input type="textarea" :rows="2" v-model="reply_content" :placeholder="'回复 @' + item.replytouser"></el-input>
                <el-button type="info" size="mini" style="margin-top: 6px;" @click="setreply(item)">回复</el-button>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li v-if="!commentlist.length" style="color: #999; text-align: center; padding: 30px 0;">
        <img :src="$img.noinfo" style="width: 120px;" />
        <p>暂无评论，快来抢沙发～</p>
      </li>
    </ol>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getComment, setComment, getReply, setReply } from '@/api'

export default {
  name: 'CommentWidget',
  data() {
    return {
      commentlist: [],
      comment_content: '',
      reply_content: '',
      editorid: -1
    }
  },
  computed: {
    ...mapState({
      commentnum: (s) => s.commentnum,
      contentid: (s) => s.contentid,
      contentname: (s) => s.contentname,
      userinfo: (s) => s.user.userinfo
    })
  },
  watch: {
    contentid() {
      this.getcomment()
    }
  },
  created() {
    this.getcomment()
  },
  methods: {
    getcomment() {
      if (!this.contentid) return
      getComment(this.contentid).then((res) => {
        this.commentlist = res.data || []
        this.$store.dispatch('setcommentnum', res.count || 0)
      })
    },
    setcomment() {
      if (!this.comment_content.trim()) {
        this.$message.error('评论内容不能为空')
        return
      }
      setComment({
        contentname: this.contentname,
        comment_content: this.comment_content,
        content_id: this.contentid,
        router: this.$route.name,
        to_userid: this.$store.state.contentuserid
      }).then(() => {
        this.$message.success('评论成功')
        this.comment_content = ''
        this.editorid = -1
        this.getcomment()
      })
    },
    getreplybutton(item) {
      if (item.showreply) { item.showreply = false; return }
      item.showreply = true
      getReply(item.comment_id).then((res) => {
        this.$set(item, 'child', res.data || [])
      })
    },
    showinput(item) {
      item.replyeditor = true
      item.replytouser = item.nickname
      item.replytouserid = item.user_id
    },
    showreplyinput(item, data) {
      item.replyeditor = true
      item.replytouser = data.nickname
      item.replytouserid = data.user_id
    },
    setreply(item) {
      if (!this.reply_content.trim()) {
        this.$message.error('回复内容不能为空')
        return
      }
      setReply({
        comment_content: this.reply_content,
        touserid: item.replytouserid,
        tousernickname: item.replytouser,
        comment_id: item.comment_id,
        router: this.$route.name,
        to_userid: this.$store.state.contentuserid,
        content_id: this.contentid,
        contentname: this.contentname
      }).then(() => {
        this.$message.success('回复成功')
        this.reply_content = ''
        item.replyeditor = false
        this.getreplybutton(item)
      })
    },
    reportUser(item) {
      this.$router.push({ path: '/jubao', query: { user: item.username, url: window.location.href } })
    }
  }
}
</script>
